type SectionProps = {
    id: string;
    children: React.ReactNode;
} & React.HTMLProps<HTMLDivElement>;

export default function Section({ id, children, ...rest }: SectionProps) {
    return (
        <section id={id} {...rest}>
            <div className='m-auto px-5 w-full max-w-6xl'>{children}</div>
        </section>
    );
}
